import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgKeyAlt = function SvgKeyAlt(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    size: size
  }, props), React.createElement("g", {
    clipPath: "url(#key-alt_svg__clip0)"
  }, React.createElement("path", {
    fill: "currentColor",
    d: "M23.61 1.587l-.418-.418a.945.945 0 00-.697-.278h-3.111a.945.945 0 00-.697.278l-8.128 8.082-.65-.65a3.865 3.865 0 00-2.787-1.162c-1.021 0-2.043.372-2.786 1.161l-3.298 3.298a3.953 3.953 0 000 5.573l4.273 4.273a3.865 3.865 0 002.787 1.161c1.021 0 2.043-.371 2.786-1.161l3.298-3.297a3.953 3.953 0 000-5.574l-.65-.65 2.461-2.462h2.973a.981.981 0 00.975-.975V5.814h2.972a.981.981 0 00.976-.976V2.284a.945.945 0 00-.279-.697zM12.789 17.1L9.49 20.397a1.967 1.967 0 01-1.393.558c-.511 0-1.022-.186-1.394-.558l-4.273-4.273a1.966 1.966 0 01-.557-1.393c0-.51.186-1.022.557-1.393L5.73 10.04a1.967 1.967 0 011.393-.557c.511 0 1.022.186 1.394.557l4.273 4.273c.79.743.79 1.997 0 2.787z"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "key-alt_svg__clip0"
  }, React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  }))));
};

export default SvgKeyAlt;